import React from 'react';

import { FormattedMessage } from '../../../../util/reactIntl';
import { ChevronGoIcon } from '../MobileHomeIcons';

import css from './SectionHomeWays.module.css';

const SectionHomeWays = () => {
  return (
    <section className={css.root}>
      <div className={css.head}>
        <h3 className={css.title}>
          <FormattedMessage id="LandingPage.mobileHome.ways.title" />
        </h3>
      </div>
      <div className={css.ways}>
        <a
          className={css.way}
          href="https://www.setcirclehelp.com/en/articles/14308263-overall-renting-guide"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className={css.badge}>
            <svg
              className={css.wayIcon}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <rect x="3.5" y="5" width="17" height="15.5" rx="2.5" fill="none" />
              <line x1="3.5" y1="10" x2="20.5" y2="10" />
              <line x1="8" y1="3" x2="8" y2="7" />
              <line x1="16" y1="3" x2="16" y2="7" />
            </svg>
          </span>
          <div className={css.tx}>
            <b>
              <FormattedMessage id="LandingPage.mobileHome.ways.rentTitle" />
            </b>
            <p>
              <FormattedMessage id="LandingPage.mobileHome.ways.rentBody" />
            </p>
          </div>
          <ChevronGoIcon className={css.go} />
        </a>
        <a
          className={css.way}
          href="https://www.setcirclehelp.com/en/articles/12787174-buying-selling-guide"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className={css.badge}>
            <svg
              className={css.wayIcon}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path
                d="M20.6 13.3 L13.4 20.5 a2 2 0 0 1-2.8 0 L3.5 13.4 V3.5 h9.9 l7.2 7 a2 2 0 0 1 0 2.8Z"
                fill="none"
              />
              <circle cx="8.3" cy="8.3" r="1.5" fill="currentColor" stroke="none" />
            </svg>
          </span>
          <div className={css.tx}>
            <b>
              <FormattedMessage id="LandingPage.mobileHome.ways.buySellTitle" />
            </b>
            <p>
              <FormattedMessage id="LandingPage.mobileHome.ways.buySellBody" />
            </p>
          </div>
          <ChevronGoIcon className={css.go} />
        </a>
        <a
          className={css.way}
          href="https://www.setcirclehelp.com/en/articles/14307871-setcircle-pro-network"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className={css.badge}>
            <svg
              className={css.wayIcon}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M3.5 7.6 L5.2 3.2 h13.6 L20.5 7.6" fill="none" />
              <path
                d="M3.5 7.6 a2.84 2.84 0 0 0 5.68 0 a2.83 2.83 0 0 0 5.64 0 a2.84 2.84 0 0 0 5.68 0"
                fill="none"
              />
              <path d="M5.2 11.6 V21 h13.6 V11.6" fill="none" />
              <path d="M9.8 21 v-5.6 h4.4 V21" fill="none" />
            </svg>
          </span>
          <div className={css.tx}>
            <b>
              <FormattedMessage id="LandingPage.mobileHome.ways.proNetworkTitle" />
            </b>
            <p>
              <FormattedMessage id="LandingPage.mobileHome.ways.proNetworkBody" />
            </p>
          </div>
          <ChevronGoIcon className={css.go} />
        </a>
      </div>
    </section>
  );
};

export default SectionHomeWays;
